import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Typography, Box } from '@mui/material';
import new_tab from '../../assests/images/new_tab.svg';
import { setSelectedCycleObj } from '../../redux/HomePage/cyclesByBuSlice';
import { getUrlWithParams } from '../../utils/Utils';

function MetricCard({
  title,
  value,
  percentdifference,
  textcolor,
  unit,
  selectedPage,
  isKPICardLoading,
  timeFrame = '',
  cyclesData,
  activeCycleId
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const newParams = new URLSearchParams(search);
  const bu = newParams.get('bu');
  let cycleObj = cyclesData?.filter((item) => item.id === activeCycleId)?.[0];
  const getColor = (textcolor) => {
    if (textcolor == 'green') {
      return '#008553';
    } else if (textcolor == 'red') {
      return '#D40020';
    }
  };
  return (
    <Box className="metric-card" textAlign="center" width={'100%'}>
      <Typography
        variant="caption"
        style={{
          fontWeight: 700,
          color: '#616161',
          fontSize: '12px',
          lineHeight: '16.8px'
        }}>
        {title}
      </Typography>
      <Typography
        variant="h4"
        className="metric-value"
        style={{
          color: '#3A3A3A',
          fontWeight: 700,
          fontSize: '31px',
          lineHeight: '44.64px',
          letterSpacing: '0%'
        }}>
        {value}
      </Typography>
      {selectedPage === 'portfoliohealth' ? (
        <Typography variant="body2" className="metric-mix">
          {percentdifference !== null || percentdifference !== '' ? (
            <>
              <span>
                <span
                  style={{
                    fontWeight: '700',
                    color: getColor(textcolor)
                  }}>
                  {percentdifference || '--'}
                </span>{' '}
                <span style={{ fontWeight: '400', color: '#616161', fontSize: '12px' }}>
                  vs Previous
                </span>{' '}
                <span style={{ color: '#616161', fontSize: '12px' }}>
                  {timeFrame === 'YTD' ? timeFrame : '13 Periods'}
                </span>
              </span>
            </>
          ) : null}
        </Typography>
      ) : (
        <></>
      )}
      {title === 'ACTIONS NOT COMPLETED' && value > 0 && (
        <a
          onClick={() => {
            dispatch(setSelectedCycleObj(cycleObj));
            navigate(
              getUrlWithParams(
                '/alignment-action/decision-making-central',
                bu,
                cycleObj?.cycleName,
                cycleObj?.id
              )
            );
          }}
          style={{
            fontWeight: 400,
            textAlign: 'left',
            textDecoration: 'none',
            color: '#005CBC',
            cursor: 'pointer'
          }}>
          {'Final Decisions'}
          <img
            src={new_tab}
            alt="icon"
            style={{ position: 'relative', top: '6px', cursor: 'pointer' }}
          />
        </a>
      )}
    </Box>
  );
}

export default MetricCard;
